import fr from './fr.json';
import en from './en.json';
import nl from './nl.json';
import de from './de.json';

export const locales = { fr, en, nl, de };
